import LegalPrivacyShell from "@/pages/LegalPrivacyShell";
import { useT } from "@/i18n/LanguageContext";

export default function Legal() {
    const { t } = useT();
    const L = t.legal;
    const sections = [
        { label: L.s1Label, heading: L.s1Heading, body: L.s1Body },
        { label: L.s2Label, heading: L.s2Heading, body: L.s2Body },
        { label: L.s3Label, heading: L.s3Heading, body: L.s3Body },
        { label: L.s4Label, heading: L.s4Heading, body: L.s4Body },
        { label: L.s5Label, heading: L.s5Heading, body: L.s5Body },
    ];
    return <LegalPrivacyShell titleKey={L.title} sections={sections} />;
}
